import React from "react";

const ServicesArea = () => (
  <div className="group-destination">
    <div className="sc-content-overlay">
      <div className="container">
        <div className="empty-space" />
        <div className="sc-heading style-01 text-center">
          <h3 className="title">Nos Services</h3>
          <p className="description">
            Chez nous, profitez d'un véritable cocktail de services dignes
            d'un complexe hotelier de haut standing. Passez des moments de
            détente, de paix, de concentration et de découverte qui ne vous
            laisseront que de très beaux souvenirs.
          </p>
        </div>
        <div className="sc-posts style-01 auto-height">
          <div className="item row">
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-1.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">Chambres</a>
                  </h3>
                  <div className="short-text">
                    {" "}
                    Des chambres de tout type
                  </div>
                  <div className="summary">
                    Votre confort passe avant tout. Nous mettons à votre
                    disposition des chambres aux commodités uniques.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'info
                  </a>
                </div>
              </div>
            </div>
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-2.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">Restauration</a>
                  </h3>
                  <div className="short-text">
                    {" "}
                    Le plaisir de bien manger
                  </div>
                  <div className="summary">
                    Notre cuisine est un mix de cultures et de saveurs qui
                    ne vous laissera jamais indifférents.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'infos
                  </a>
                </div>
              </div>
            </div>
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-3.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">Evènements</a>
                  </h3>
                  <div className="short-text"> Soirées et vibes</div>
                  <div className="summary">
                    A Songon Park, nos soirées resteront gravées dans le
                    livre de vos plus beaux souvenirs.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'infos
                  </a>
                </div>
              </div>
            </div>
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-4.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">La terrase</a>
                  </h3>
                  <div className="short-text">
                    {" "}
                    Installez-vous, discutez, buvez
                  </div>
                  <div className="summary">
                    Un salon ouvert. Retrouvez-vous et parlez de tout et de
                    rien en contemplant la beauté du paysage.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'infos
                  </a>
                </div>
              </div>
            </div>
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-5.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">Jet Ski</a>
                  </h3>
                  <div className="short-text"> Le plaisir des eaux</div>
                  <div className="summary">
                    Allez à la conquête des eaux et à la découverte de la
                    nature en chevauchant l'un de nos nombreux jets.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'infos
                  </a>
                </div>
              </div>
            </div>
            <div className="post col-sm-6 col-md-4">
              <div className="inner">
                <div className="thumbnail">
                  <a href="blog-single.html">
                    <img src="images/gallery/img-6.jpg" alt="" />
                  </a>
                </div>
                <div className="content">
                  <h3 className="title">
                    {" "}
                    <a href="blog-single.html">Kids Events</a>
                  </h3>
                  <div className="short-text">
                    {" "}
                    Les tout petits au coeur de la vie
                  </div>
                  <div className="summary">
                    Chez nous, les enfants sont au centre de l'animation du
                    site. Nous avons tout type d'activités et
                    d'infrastructures pour eux.
                  </div>
                  <a href="blog-single.html" className="read-more">
                    Plus d'infos
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ServicesArea;
